import instance from "../utils/network";

export enum SeedLogType {
  CREATE = "CREATE",
  WITHDRAW = "WITHDRAW",
  WITHDRAW_CANCEL = "WITHDRAW_CANCEL",
  PUB_WITHDRAW = "PUB_WITHDRAW",
  PUB_USE = "PUB_USE",
  PUB_USE_CANCEL = "PUB_USE_CANCEL",
  PUB_TO_USER = "PUB_TO_USER",
  BOUNTY = "BOUNTY",
  USER_USE = "USER_USE",
  USER_USE_CANCEL = "USER_USE_CANCEL",
  USER_CREATE = "USER_CREATE",
  USER_CREATE_CANCEL = "USER_CREATE_CANCEL",
  RESERVATION = "RESERVATION",
  RESERVATION_CANCEL = "RESERVATION_CANCEL",
  RESERVATION_DISCOUNT = "RESERVATION_DISCOUNT",
  RESERVATION_DISCOUNT_CANCEL = "RESERVATION_DISCOUNT_CANCEL",
  COMPANY_ADDITIONAL = "COMPANY_ADDITIONAL",
  COMPANY_ADDITIONAL_CANCEL = "COMPANY_ADDITIONAL_CANCEL",
  ADMIN_TOURNAMENT_REWARD = "ADMIN_TOURNAMENT_REWARD",
}

export interface SeedLogDto {
  createdAt: Date;
  seed: number;
  type: SeedLogType;
  pubName: string;
}

export interface SeedHistoryResponse {
  date: string;
  list: SeedLogDto[];
}

export function mySeedLog(
  year: number,
  month: number
): Promise<SeedHistoryResponse[]> {
  return instance.get("/nest/seed/log", {
    params: {
      year,
      month,
    },
  });
}

export function mySeed(): Promise<number> {
  return instance.get("/nest/seed/value");
}
